// Route + storage keys used for navigation.
//
// These live here, in a module that imports NOTHING, on purpose. They used to be
// declared in the route/layout files themselves, so any component that needed a key
// had to import from a route file -- and those route files import components right
// back. That produced 83 `Require cycle:` warnings, which were being papered over by
// LogBox.ignoreLogs(['Require cycle']) in AppSetup rather than fixed. A leaf module
// breaks every one of those cycles without changing a single navigation path.
//
// Keep this file dependency-free.

export const activityKey = 'activity';
export const anonymousReckoningPresentionKey = 'introduction';
export const anonymousStackKey = '(anonymous)';
export const assistanceKey = 'assistance';
export const assistanceStackKey = '(Assistance)';
export const branchingKey = 'branching';
export const breatheKey = 'choice';
export const breatheSettingKey = 'settings';
export const breatheStackKey = 'breathe';
export const chooseNewPathKey = 'choose-new-path';
export const contactKey = 'contact';
export const contentStackKey = 'content';
export const dashboardKey = 'dashboard';
export const dashboardStackKey = '(Dashboard)';
export const exerciceKey = 'exercice';
export const exerciseKey = 'exercise';
export const faceScanStackKey = 'face_scan';
export const forgetPasswordKey = 'forget-password';
export const genericKey = 'generic';
export const healthDashboardSettingKey = 'health_dashboard';
export const healthProfileKey = 'health';
export const healthStackKey = '(Health)';
export const helpdeskKey = 'helpdesk';
export const instantHelpStackKey = 'instant-help';
export const libraryKey = 'library';
export const libraryStackKey = '(Library)';
export const needUpdateKey = 'need-update';
export const organizationAssistanceKey = 'organization-assistance';
export const pathKey = 'path';
export const phoneKey = 'phone';
export const privateKey = '(private)';
export const psychologistDetailKey = 'psychologist-detail';
export const publicKey = '(public)';
export const reckoningIdStorageKey = 'reckoningId';
export const reckoningResultKey = 'survey-result';
export const reckoningSessionIdStorageKey = 'sessionId';
export const redirectLoginRegisterKey = 'login-register';
export const regularSessionKey = 'regular';
export const sessionStackKey = 'session';
export const settingKey = 'setting';
export const settingStackKey = '(Setting)';
export const staticPageKey = 'staticpage';
export const tabsKey = '(Tabs)';
export const thankYouKey = 'thank-you';
export const tryAgainKey = 'try-again';
export const videocallKey = 'video';
export const visitedPageDashboardKey = 'DASHBOARD';
export const visitedPagePathKey = 'PATH';
export const yourNextAppointmentKey = 'your-next-appointment';
export const profileStackKey = healthStackKey;
export const loginKey = 'login'; // must match the file name
export const registerKey = 'register'; // must match the file name

export const onlyPublicKeys = [loginKey, registerKey, forgetPasswordKey, needUpdateKey, contactKey, redirectLoginRegisterKey];
export const publicKeys = onlyPublicKeys.concat([staticPageKey]);
